import React from "react";

function ActionRow({
  children,
  gap = 10,
  style = {},
}) {
  return (
    <div
      style={{
        display: "flex",
        gap,
        flexWrap: "wrap",
        alignItems: "center",
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export default ActionRow;